module.exports = {"version":"2026.715.0"}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 2959
// module chunks = 4